import React from 'react';

import { Box } from '@mui/material';

import useTenantTranslation from '~/hooks/useTenantTranslation';
import CategoryNavigationLink from '~/pages/DiscoverPage/components/CategoryNavigationLink';
import { DISCOVER_SEARCH_ROUTE } from '~/routes';

const SkillNavigationBlock = () => {
  const { t } = useTenantTranslation();

  return (
    <Box>
      <CategoryNavigationLink data-testid="backToAllSkillsLink" to={DISCOVER_SEARCH_ROUTE}>
        {t('page.discover.backToSkills')}
      </CategoryNavigationLink>
    </Box>
  );
};

export default SkillNavigationBlock;
